import { AdapterLink } from "../../../components/Adopter";
import React from "react";
import { useCallback } from "react";
import { useSnackbar } from "notistack";
import Dialog from "../../../components/Dialog";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { Theme } from "@material-ui/core";
import LabeledContent from "../../../components/LabeledContent";
import { Routes } from "../../../constants/routes";
import FontIcon from "../../../components/FontIcon";
import { Exam } from "../types";
import useExamQueries from "../hooks/useExamQueries";
import IconButton from "../../../components/IconButton";
import { mutateErrors } from "../../../utils";

const useStyles = makeStyles((theme: Theme) => ({
  content: {
    marginBottom: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      borderBottom: "1px solid #dfdcd6",
    },
  },
  buttonsContainer: {
    display: "flex",
    textAlign: "center",
    justifyContent: "space-between",
  },
  paper: {
    padding: theme.spacing(3),
  },
}));

export default function ExamListItem({
  index,
  onDelete,
  exam,
}: {
  index: number;
  onDelete: Function;
  exam: Exam;
}) {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const { fetchDelete } = useExamQueries();

  const handleDelete = useCallback(async () => {
    try {
      await fetchDelete(exam.id);
      enqueueSnackbar("Success", { variant: "success" });
    } catch (e) {
      const { message } = mutateErrors(e);
      enqueueSnackbar(message, { variant: "error" });
    }
    if (typeof onDelete == "function") onDelete();
    closeDialog();
  }, [fetchDelete, exam]); // eslint-disable-line react-hooks/exhaustive-deps

  const openDialog = useCallback(() => {
    setDialogOpen(true);
  }, []);

  const closeDialog = useCallback(() => {
    setDialogOpen(false);
  }, []);

  return (
    <>
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <Grid
            container
            spacing={2}
            justify={"space-between"}
            alignItems={"center"}
          >
            <Grid item xs={12} sm={9} className={classes.content}>
              <LabeledContent label={"name"}>{exam.name}</LabeledContent>
            </Grid>
            <Grid item xs={12} sm={"auto"} className={classes.buttonsContainer}>
              <div>
                <IconButton
                  color={"edit"}
                  component={AdapterLink}
                  to={`/0/${Routes.EXAMS}/${exam.id}/edit`}
                >
                  <FontIcon fontSize={"small"} name={"edit"} />
                </IconButton>
              </div>
              <div>
                <IconButton color={"delete"} onClick={openDialog}>
                  <FontIcon fontSize={"small"} name={"delete"} />
                </IconButton>
              </div>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
      <Dialog
        open={dialogOpen}
        title="Are you sure?"
        contentText="You won't be able to revert this!"
        onClose={closeDialog}
        actions={[
          {
            text: "Cancel",
            color: "primary",
            onClick: closeDialog,
          },
          {
            text: "Delete",
            color: "primary",
            onClick: handleDelete,
          },
        ]}
      />
    </>
  );
}
